export class TourExpenseHeadModel 
{
    public ExpenseHeadId: number;
    public ExpenseHeadCode :string;
    public ExpenseHeadName: string;
}